import type { EntityData } from '@adornis/baseql/entities/types.js';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { Student, StudentTags } from '../entities/Student.js';

/**
 * Removes the tag FROM_OS_ACQUISITION from the student with the given id.
 *
 * @query removeOSAcquisitionTagStudent
 * @param id - The id of the student to remove the tag from
 */
export const removeOSAcquisitionTagStudent = registerQuery({
  type: () => Boolean,
  operationName: 'removeOSAcquisitionTagStudent',
  resolve: (id: string) => {
    return async () => {
      const col = await getRawCollection<EntityData<Student>>(Student._collectionName);
      // @ts-expect-error
      col.updateOne({ _id: id }, { $pull: { tags: StudentTags.FROM_OS_ACQUISITION } });
      return true;
    };
  },
  options: {},
  params: [{ type: () => String, name: 'similar' }],
});
